import Vue from "vue";
import Router from "vue-router";

import staff from './staff.js'
import family from './family.js'

Vue.use(Router);

//添加以下代码 vue-router解决相同路径跳转报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const defaultRouters = [
// 登陆
  {
    path: "/login",
    component: resolve => require(["@/pages/login/login"], resolve),
    meta: { title: "登陆" }
  },
  // 问卷外部评价
  {
    path: "/satisfaction/external",
    component: resolve =>
      require(["@/pages/satisfaction/externalEvaluation"], resolve),
    meta: { title: "问卷评价" }
  },
  {
    path: "/assets/detail",
    component: resolve => require(["@/pages/external/assets/components/layout"], resolve),
    meta: { title: "固定资产" },
    children: [
      {
        path: '/assets/detail',
        component: resolve => require(["@/pages/external/assets/detail"], resolve),
        meta: { title: '资产详情' }
      }
    ]
  },
  // {
  //   path: '/404',
  //   name: 'NotFound',
  //   component: resolve => require(["@/pages/login/login"], resolve),
  // },
  // {
  //   path: '*',
  //   redirect: '/404'
  // }
]

const createRouter = () => new Router({
  mode: "history",
  routes: defaultRouters
});

const currentRoute = createRouter()

export function roleRoute(type) {
  resetRoute()
  if (type == 1) {
    let newRouter = [...defaultRouters, ...staff]
    currentRoute.options.routes = newRouter
    newRouter.forEach(r => {
      currentRoute.addRoute(r)
    })
  } else if (type == 2) {
    let newRouter = [...defaultRouters, ...family]
    currentRoute.options.routes = newRouter
    newRouter.forEach(r => {
      currentRoute.addRoute(r)
    })
  }
  return true
}

export function resetRoute() {
  const newRouter = createRouter()
  currentRoute.matcher = newRouter.matcher
}

//子页面
export default currentRoute



// WEBPACK FOOTER //
// ./src/router/index.js